import type { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import type { ChildGenderEnum } from '@sola/schema/dotcom/children/childUtilityInterfaces.ts';
import { mockChildDetails } from '@sola/schema/dotcom/children/mocks.ts';
import type {
  GraphQLCommitment,
  GraphQLSupporter,
} from '@sola/schema/dotcom/supporters/schema.generated.ts';

type Participant = NonNullable<GraphQLCommitment['participant']>;

const mapParticipantToChildDetails = (
  participant: Participant,
): ChildDetails => ({
  ...mockChildDetails,
  birthDate: participant.birthdate
    ? `${participant.birthdate} 00:00:00`
    : mockChildDetails.birthDate,
  country: participant.country ?? mockChildDetails.country,
  gender: (participant.gender as ChildGenderEnum) ?? mockChildDetails.gender,
  globalId: participant.globalId ?? mockChildDetails.globalId,
  imageUrl: participant.photoUrl ?? mockChildDetails.imageUrl,
  localId: participant.localId ?? mockChildDetails.localId,
  name: {
    first: participant.name ?? mockChildDetails.name.first,
    preferred:
      participant.names?.preferred ??
      participant.name ??
      mockChildDetails.name.preferred,
  },
});

export const getMockChildDetails = ({
  childId,
  supporter,
}: {
  childId: string;
  supporter: GraphQLSupporter;
}): ChildDetails | null => {
  const participant = supporter.commitments
    ?.map((commitment: GraphQLCommitment) => commitment.participant)
    .find(
      (
        candidate: GraphQLCommitment['participant'],
      ): candidate is Participant => {
        return !!candidate?.globalId && candidate.globalId === childId;
      },
    );

  if (!participant) {
    return null;
  }

  return mapParticipantToChildDetails(participant);
};
